module.exports = __webpack_public_path__ + "img/_112.3cf92548.png";